"use client";

import { PersonalDataListener } from "./PersonalDataListener";
import { ThirdPartiesListener } from "./ThirdPartiesListener";

export const Listeners = () => (
  <>
    <PersonalDataListener />
    <ThirdPartiesListener />
  </>
);
